import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    loading: false,
    activo: false,
    data: {},
    fc_30: {},
    productos: {},
    paginaActiva: 1,
    fc_30Map: {},
    productosMap: [],
    modoProceso: false,
    modoVerDetalle: false,
    modoRecibidasCorregidas: false,
}


//types
const LOADING = 'LOADING'
const ACTUALIZAR_FC_30_PAGINA = 'ACTUALIZAR_FC_30_PAGINA'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const ACTUALIZAR_FC_30_ESTATUS_EXITO = 'ACTUALIZAR_FC_30_ESTATUS_EXITO'
const AGREGAR_FC_30_EXITO_MAP = 'AGREGAR_FC_30_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_30_MAP_EXITO = 'OBTENER_FC_30_MAP_EXITO'
const ACTUALIZAR_FC_30_EXITO = 'ACTUALIZAR_FC_30_EXITO'
const ACTUALIZAR_FC_30_MAP_EXITO = 'ACTUALIZAR_FC_30_MAP_EXITO'
const OBTENER_DETALLE_FC_30_EXITO = 'OBTENER_DETALLE_FC_30_EXITO'
const GENERAR_OFICIOS_FC30_EXITO = 'GENERAR_OFICIOS_FC30_EXITO'
const OBTENER_DETALLE_FC_30_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_30_CON_MAPS_EXITO'
const ACEPTAR_SOLICITUD_FC30_EXITO = 'ACEPTAR_SOLICITUD_FC30_EXITO'
const ACTUALIZAR_FC_30_FORMULARIO_EXITO = 'ACTUALIZAR_FC_30_FORMULARIO_EXITO'

export const actualizarFC_30Estatus = createAsyncThunk(
    ACTUALIZAR_FC_30_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }

)
export const obtenerSolicitudDetalleFC_30 = createAsyncThunk(
    OBTENER_DETALLE_FC_30_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_30/obtenerFormatoFC30_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_30Accion = createAsyncThunk(
    AGREGAR_FC_30_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud }
            let productosMap = data.productosMap
            let archivosProductosMap = data.archivosProductosMap
            delete solicitud.idfc30_notificaciontrasladodeprmap
            const agregarFC_30Map = host + 'MapSolicitud/agregarMapFC_30_NotificacionTraslado'
            const agregarFC_30ProductosMap = host + 'MapSolicitud/agregarMapFC_30_AnexoProducto'
            const agregarFC_30ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_30_ArchivosProductos`

            const res = await axios.post(agregarFC_30Map, solicitud)

            for (const anexo of productosMap) {
                delete anexo.idfc30_anexoproductomap
                await axios.post(agregarFC_30ProductosMap, { data: anexo })
            }
            for (const anexo of archivosProductosMap) {
                delete anexo.idfc_30archivoproductomap
                await axios.post(agregarFC_30ArchivosproductosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_30Map = createAsyncThunk(
    OBTENER_FC_30_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_30_NotificacionTraslado/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            const Map = await obtenerProductosMap(solicitudId)
            productosMap.push(Map.anexoProductoMap)
            filesProductosMap.push(Map.filesProductosMap)

            const solicitudMap = {
                data: res.data.data,
                //mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_30/obtenerFormatoFC30_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_30_AnexoProducto/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_30_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_30archivos
        const filesProductos = res.data.data.fc_30_anexoproducto
        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_30archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_30archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_30archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            }
        }
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_30_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc30_anexoproducto)
            anexoProductoMap.push(resMap.data.data)
        }
        let Map = { anexoProductoMap: anexoProductoMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_30SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_30_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const idfc30_notificaciontrasladodeprmap = data.idfc30_notificaciontrasladodeprmap
            const productosParaActualizar = data.productosMap
            const archivosPrincipalMap = data.archivosPrincipalMap
            const archivosProductosMap = data.archivosProductosMap
            const agregarFC_30ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_30_ArchivosProductos`
            const actualizarFC_30Map = host + `MapSolicitud/actualizarMapFC_30_NotificacionTraslado`
            const urlActualizarAnexoProductos = host + 'MapSolicitud/actualizarMapFC_30_AnexoProducto'
            const urlActualizarArchivosproductos = host + 'MapSolicitud/actualizarMapFC_30_ArchivosProductos'
            const res = await axios.put(actualizarFC_30Map, { data: solicitud.data })

            for (let anexo of productosParaActualizar) {
                let resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
            }
            for (let anexo of archivosProductosMap) {
                if (anexo.idfc_30archivoproductomap != "" && anexo.idfc_30archivoproductomap != null && anexo.idfc_30archivoproductomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivosproductos, { data: anexo })
                } else {
                    delete anexo.idfc_30archivoproductomap
                    let resAnexo = await axios.post(agregarFC_30ArchivosproductosMap, { data: anexo })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_30Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_30_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosParaActualizarProductos = data.archivosProductos

            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`
            const urlActualizarArchivosProductos = host + 'FC_30/actualizarArchivoProductoFC_30'
            //const res = await axios.put(actualizarFC_30, solicitud)
            for (const anexo in archivosParaActualizarProductos) {
                let resAnexo = await axios.put(urlActualizarArchivosProductos, { data: archivosParaActualizarProductos[anexo] })
            }
            //return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const generarDocumentosFC_30 = createAsyncThunk(
    GENERAR_OFICIOS_FC30_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerSolicitudDetalleFC_30ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_30_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_30/obtenerFormatoFC30_ConDetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const aceptarSolicitudFC_30 = createAsyncThunk(
    ACEPTAR_SOLICITUD_FC30_EXITO,
    async (data) => {
        try {
            const { idcliente, idfc30_notificaciontrasladodepr, productos } = data
            const urlAgregarProductosCliente = host + 'InformacionValida/agregarProductosCliente'
            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'

            for (let i in productos) {
                const { idfc30_anexoproducto, idfc30_notificaciontrasladodepr, fc_30archivoproducto, ...anexo } = productos[i]
                anexo.idcliente = idcliente
                anexo.idtipoproductos = 3
                const resProducto = await axios.post(urlAgregarProductosCliente, { data: anexo })
                const idproductocliente = resProducto.data.data.idproductocliente
                for (const j in fc_30archivoproducto) {
                    const { idfc_30archivoproducto, idfc30_anexoproducto, fc_30archivoproductomap, ...restFile } = fc_30archivoproducto[j]
                    restFile.nombreTabla = 'archivoproductocliente'
                    restFile.nameFK = 'idproductocliente'
                    restFile.idFK = idproductocliente
                    restFile.observaciones = fc_30archivoproductomap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_30Formulario = createAsyncThunk(
    ACTUALIZAR_FC_30_FORMULARIO_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }

            const actualizarFC_30 = host + `FC_30/actualizarFC_30TrasladoProducto`
            const res = await axios.put(actualizarFC_30, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc30Slice = createSlice({
    name: 'fc30Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_30(state, { payload }) {
            state.paginaActiva = payload
        },
        resetDataFC_30(state, { payload }) {
            return dataInicial
        },
        setModoProcesoFC_30(state, { payload }) {
            state.modoProceso = payload
        },
        setModoVerDetalleFC_30(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_30(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
    },
    extraReducers: {
        [obtenerSolicitudDetalleFC_30.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [agregarMapFC_30Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_30Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_30Map.fulfilled]: (state, { payload }) => {
            state.fc_30Map = payload.data
            state.productosMap = payload.productosMap[0]
            state.filesProductosMap = payload.filesProductosMap[0]
        },
        [actualizarFC_30Solicitud.fulfilled]: (state, { payload }) => {
        },

    },
})

//actions
export const {
    setModoProcesoFC_30, setModoVerDetalleFC_30, setModoRecibidasCorregidasFC_30,
    actualizarPaginaActivaFC_30,
    resetDataFC_30
} = fc30Slice.actions

export const FC30ReducerAtencionACliente = fc30Slice.reducer